"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FontWeight;
(function (FontWeight) {
    FontWeight["Light"] = "ty-font-w-light";
    FontWeight["Normal"] = "ty-font-w-normal";
    FontWeight["SemiBold"] = "ty-font-w-semi-bold";
    FontWeight["Bold"] = "ty-font-w-bold";
})(FontWeight = exports.FontWeight || (exports.FontWeight = {}));
